/**
 * The `ch-grid-rowset` component represents a group of rows.
 */
export default class HTMLChGridRowsetElement extends HTMLElement {
    computedLevel = 0;
    grid;
    constructor() {
        super();
    }
    connectedCallback() {
        this.addEventListener("rowsetLegendClicked", this.rowsetLegendClickedHandler);
        this.defineLevel();
    }
    /**
     * A boolean value indicates whether the grid rowset is collapsed.
     */
    get collapsed() {
        return this.hasAttribute("collapsed");
    }
    set collapsed(value) {
        if (value) {
            this.setAttribute("collapsed", "");
        }
        else {
            this.removeAttribute("collapsed");
        }
    }
    /**
     * Gets the zero-based depth of the rowset in the tree.
     */
    get level() {
        if (!this.computedLevel) {
            this.computeLevel();
        }
        return this.computedLevel;
    }
    /**
     * returns a `DOMRect` object representing the size of the grid rowset element.
     */
    getBoundingClientRect() {
        let rect;
        const paddingTop = parseInt(this.style.getPropertyValue("padding-top"));
        const paddingbottom = parseInt(this.style.getPropertyValue("padding-bottom"));
        if (!this.firstElementChild) {
            const mainRect = this.grid.shadowRoot
                .querySelector(".main")
                .getBoundingClientRect();
            rect = new DOMRect(mainRect.x, mainRect.y, mainRect.width, 0);
        }
        else if (this.firstElementChild === this.lastElementChild) {
            const firstRowRect = this.firstElementChild.getBoundingClientRect();
            rect = new DOMRect(firstRowRect.x, firstRowRect.y - paddingTop, firstRowRect.x + firstRowRect.width, firstRowRect.y + firstRowRect.height + paddingTop + paddingbottom);
        }
        else {
            const firstRowRect = this.firstElementChild.getBoundingClientRect();
            const lastRowRect = this.lastElementChild.getBoundingClientRect();
            rect = new DOMRect(firstRowRect.x, firstRowRect.y - paddingTop, lastRowRect.x - firstRowRect.x + lastRowRect.width, lastRowRect.y -
                firstRowRect.y +
                lastRowRect.height +
                paddingTop +
                paddingbottom);
        }
        return rect;
    }
    rowsetLegendClickedHandler(eventInfo) {
        eventInfo.stopPropagation();
        this.collapsed = !this.collapsed;
    }
    defineLevel() {
        this.style.setProperty("--level", this.level.toString());
    }
    computeLevel() {
        this.computedLevel = this.getParentRowset()?.level ?? 0;
        if (this.hasLegend() || this.isNestedRow()) {
            this.computedLevel++;
        }
    }
    hasLegend() {
        return this.firstElementChild?.tagName === "CH-GRID-ROWSET-LEGEND";
    }
    isNestedRow() {
        return this.parentElement.tagName === "CH-GRID-ROW";
    }
    getParentRowset() {
        const node = this.parentElement.closest("ch-grid-rowset, ch-grid");
        if (node.tagName === "CH-GRID-ROWSET") {
            return node;
        }
    }
}
if (!customElements.get("ch-grid-rowset")) {
    customElements.define("ch-grid-rowset", HTMLChGridRowsetElement);
}
//# sourceMappingURL=ch-grid-rowset.js.map
